// 아이템 아이콘 한 칸(DOM). 경로가 없으면 칸을 만들지 않고, 그림을 못 읽으면 그림만 숨긴다(칸·테두리·배지는 남아 행 높이와 배치가 그대로).
import { assetUrl } from '../pwa/assetMap';
import { el } from './dom';

/** parent 맨 앞에 size px 정사각 아이콘. color가 있으면 등급색 은은한 테두리 */
export function itemIcon(parent: HTMLElement, path: string | null, size: number, color?: string, first = true): HTMLDivElement | null {
  if (!path) return null;
  const box = el('div', `flex:0 0 auto;width:${size}px;height:${size}px;border-radius:9px;display:grid;place-items:center;` +
    'background:radial-gradient(circle at 50% 42%,rgba(255,255,255,.10),rgba(10,14,30,.0) 70%),rgba(8,12,26,.55);' +
    `border:1.5px solid ${color ?? 'rgba(242,193,78,.35)'};box-shadow:inset 0 0 10px rgba(0,0,0,.45);`);
  if (first && parent.firstChild) parent.insertBefore(box, parent.firstChild); else parent.appendChild(box);
  const img = el('img', `width:${Math.round(size * 0.9)}px;height:${Math.round(size * 0.9)}px;object-fit:contain;filter:drop-shadow(0 2px 3px rgba(0,0,0,.55));`, box);
  img.alt = '';
  img.decoding = 'async';
  img.draggable = false;
  img.addEventListener('error', () => { img.style.visibility = 'hidden'; });
  img.src = assetUrl(path);
  box.dataset.testid = 'item-icon';
  return box;
}
